import Model, { belongsTo } from '@ember-data/model';

export default class TeamPlaylistModel extends Model {
  @belongsTo('team', { inverse: 'teamPlaylists', async: false }) team;
  @belongsTo('playlist', { inverse: 'teamPlaylists', async: false }) playlist;
}
